import React from "react";
import type { TooltipProps } from "recharts";
import { cn } from "@/lib/utils";

interface TooltipItem {
  label: string;
  count: number | string;
}

interface PayloadWithDetails {
  label: string;
  details: TooltipItem[];
}

interface Props extends TooltipProps<number, string> {
  getColor?: (index: number) => string;
}

export const ChartTooltipList = ({
  active,
  payload,
  getColor = (i) => `var(--chart-${(i % 6) + 1})`,
}: Props) => {
  if (!active || !payload?.length) return null;

  const raw = payload[0]?.payload as PayloadWithDetails;
  const { label, details } = raw;

  if (!label || !Array.isArray(details)) return null;

  return (
    <div
      className={cn(
        "grid min-w-[220px] items-start gap-2 rounded-md border border-border/50 bg-popover px-3 py-2 text-sm text-xs shadow-xl",
      )}
    >
      <div className="font-semibold text-popover-foreground">{label}</div>
      <div className="grid gap-1.5">
        {details.map((item, index) => (
          <div
            key={item.label}
            className="flex items-center justify-between gap-2"
          >
            <div className="flex items-center gap-2">
              <div
                className="h-2 w-2 shrink-0 rounded-full"
                style={{ backgroundColor: getColor(index) }}
              />
              <span className="text-muted-foreground">{item.label}</span>
            </div>
            <span className="font-mono font-medium text-popover-foreground tabular-nums">
              {item.count ?? "-"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
